import { ROUTE_PIPELINES } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { useLocation } from 'react-router-dom';
import flowTypes from '../../flowTypes';
import useFlowParams from 'new/components/flows/useFlowParams';

const FLOW_TYPES_PATTERN = Object.values(flowTypes).join('|');

type UseFlowType = keyof typeof flowTypes;
export default function useFlowType(): UseFlowType {
  const { flowType: propFlowType } = useFlowParams();
  const { pathname } = useLocation();

  const match = pathname?.match(
    new RegExp(`${ROUTE_CONNECT}${ROUTE_PIPELINES}/(${FLOW_TYPES_PATTERN})/`),
  );

  const testPath = match ? (match[1] as UseFlowType) : flowTypes['streaming'];

  return (propFlowType as UseFlowType) || testPath;
}
